import React from 'react';
import { Button, Drawer, Select, Tabs } from 'antd';
import TypologyDetailsTab from './Tabs/typologyDetails';
import NotesTab from './Tabs/notes';
import ActivityLogTab from './Tabs/activityLog';
import ReportTab from './Tabs/report';
import style from './index.scss';
import TypologiesList from './Tabs/typologiesList';
import RunInstanceHistory from './Tabs/runInstanceHistory';
import RiskIndicators from './Tabs/riskIndicators';

const { TabPane } = Tabs;
const { Option } = Select;

export const typologyTabsConfig = [
  {
    componentName: <TypologyDetailsTab />,
    tabName: 'Typology Details'
  },
  {
    componentName: <NotesTab />,
    tabName: 'Notes'
  }
];

export const scenarioTabsConfig = [
  {
    componentName: <ActivityLogTab />,
    tabName: 'Activity Log'
  },
  {
    componentName: <TypologiesList showRemoveOption={false} />,
    tabName: 'Typologies'
  }
];

export default class TRMDrawer extends React.Component {
  state = { visible: false, activeTabID: 0, record: {} };

  showDrawer = (defaultTab, record) => {
    this.setState({
      visible: true,
      record: record
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  tabsCallback = (tabID) => {
    this.setState({ activeTabID: parseInt(tabID) });
  };

  render() {
    const { tabsConfig = [] } = this.props;
    const { record = {} } = this.state;
    const { name = '', id = '' } = record;
    return (
      <>
        <Drawer
          title={name}
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          destroyOnClose={true}
          footer={
            <div
              style={{
                textAlign: 'right'
              }}>
              <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button onClick={this.onClose} type="primary">
                Submit
              </Button>
            </div>
          }>
          <Tabs onChange={this.tabsCallback}>
            {tabsConfig.map((tabConfig, idX) => {
              const { componentName, tabName } = tabConfig;
              return (
                <TabPane
                  tab={
                    <span
                      className={
                        this.state.activeTabID === idX
                          ? style.tabClassActive
                          : style.tabClass
                      }>
                      {tabName}
                    </span>
                  }
                  key={idX}>
                  {tabName === 'Typologies' || tabName === 'Activity Log'
                    ? React.cloneElement(componentName, { scenarioID: id })
                    : componentName}
                </TabPane>
              );
            })}
          </Tabs>
        </Drawer>
      </>
    );
  }
}
